import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { actions } from 'slices/app.slice'
import { useDispatch, useSelector } from 'react-redux'
import { path } from 'utils/const'
import { images } from '../../assets'
import style from './profileView.module.css'
import BackComponent from "../../components/BackComponent/BackComponent";
// eslint-disable-next-line import/imports-first

function ProfileView(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { me } = useSelector((state) => state.app)

  // eslint-disable-next-line no-shadow
  const changePassword = () => {
    navigate(path.changepassword)
  }
  const navigateToDoctorInformation = () => {
    navigate(path.doctorinformation)
  }
  return (
    <div>
      <BackComponent
        title={"Back"}
      />
      <div className={style.profilePic}>
        <img
          src={me.profileImageURL || images.pic}
          className={style.img}
          alt="logo"
        />
      </div>
      <div className={style.account}>
        <p className={style.fontColor}>Account settings</p>
      </div>
      <div>
        <button
          onClick={navigateToDoctorInformation} className={
            style.information
          }
        >
          <span>Personal information</span>
          <img
            src={images.forwardIcon}
            className={style.forwardIcon}
            alt="logo"
          />
        </button>
      </div>
      <div className={style.line}></div>
      <div>
        <button onClick={changePassword} className={style.information}>
          <span>Change password</span>
          <img
            src={images.forwardIcon}
            className={style.forwardIcon}
            alt="logo"
          />
        </button>
      </div>
      <div className={style.line}></div>

      <div className={style.logoutButton}>
        <button onClick={() => dispatch(actions.logout())}>Logout</button>
      </div>
    </div>
  )
}

export default ProfileView
